import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Router} from "@angular/router";
import {Api} from "../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../common/services/toast.service";
import {UserService} from "../../../../../../common/services/user.service";
import {ModalService} from "../../../../../services/modal.service";
import {SpinnerService} from "../../../../../../common/services/spinner.service";
import {ServiceLevelService} from "../../../../../../common/services/service-level.service";
import {Api3Service} from "../../../../../../common/services/api3.service";

@Component({
    selector: "section-warehouse-order-consolidated-list",
    template: `
        <common-confirm></common-confirm>

        <h1 class="container-heading">Consolidated orders</h1>
        <mat-card>
            <mat-card-content>
                <table class="table text-center">
                    <thead>
                    <tr class="table-header-title">
                        <th width="70">Partner</th>
                        <th width="40"></th>
                        <th>Order ref</th>
                        <th>Shipment ref</th>
                        <th>Service level</th>
                        <th>Order type</th>
                        <th>Status</th>
                        <th>Incoterms</th>
                        <th>Order status</th>
                        <th>Created at</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let partner_orders of shipments">
                        <tr *ngIf="partner_orders.length">
                            <td [rowSpan]="partner_orders.length+1">

                                <img [src]="partner_orders[0].partner_icon_path"
                                     [alt]="partner_orders[0].partner_name"
                                     [title]="partner_orders[0].partner_name">

                            </td>
                            <td>
                                <button mat-mini-fab type="button" color="warn"
                                        (click)="openOutboundProcedure(partner_orders[0].warehouse_order_id_1,
                                        partner_orders[0].order_ref_1,partner_orders[0].order_id_1)">
                                    <mat-icon class="mat-icon material-icons">arrow_upward</mat-icon>
                                </button>
                            </td>
                            <td>
                                {{ partner_orders[0].order_ref_1 }}
                            </td>
                            <td>
                                {{ partner_orders[0].shipment_ref_1 }}
                            </td>
                            <td>
                                {{ service_levels[partner_orders[0].service_level_id_1].name }}
                            </td>
                            <td>
                                {{ service_levels[partner_orders[0].service_level_id_1].order_type.display_name }}
                            </td>
                            <td>
                                {{ statuses[partner_orders[0].warehouse_order_status_id_1] }}
                            </td>
                            <td>
                                {{ partner_orders[0].incoterms_1 }}
                            </td>
                            <td>
                                {{ statuses[partner_orders[0].order_status_id_1] }}
                            </td>
                            <td>
                                {{ partner_orders[0].order_created_at_1 }}
                            </td>
                            <td [rowSpan]="partner_orders.length+1">
                                <button mat-raised-button type="button" color="accent"
                                        (click)="exportUniversalPickList(partner_orders[0].shipment_id_1)">
                                    Download consolidated picklist
                                </button>
                            </td>
                        </tr>

                        <tr *ngFor="let order of partner_orders">
                            <td>
                                <button mat-mini-fab type="button" color="warn"
                                        (click)="openOutboundProcedure(order.warehouse_order_id_1,
                                        order.order_ref_1, order.order_id_1)">
                                    <mat-icon class="mat-icon material-icons">arrow_upward</mat-icon>
                                </button>
                            </td>
                            <td>
                                {{ order.order_ref_2 }}
                            </td>
                            <td>
                                {{ order.shipment_ref_2 }}
                            </td>
                            <td>
                                {{ service_levels[order.service_level_id_2].name }}
                            </td>
                            <td>
                                {{ service_levels[order.service_level_id_2].order_type.display_name }}
                            </td>
                            <td>
                                {{ statuses[order.warehouse_order_status_id_2] }}
                            </td>
                            <td>
                                {{ order.incoterms_2 }}
                            </td>
                            <td>
                                {{ statuses[order.order_status_id_2] }}
                            </td>
                            <td>
                                {{ order.order_created_at_2 }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="11" style="background: #263238; padding: 0 !important; height: 1px"></td>
                        </tr>
                    </ng-container>
                    </tbody>
                </table>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderConsolidatedListComponent implements OnInit, Base.IComponent {


    public readonly state: Base.IState;

    public shipments: any[] = [];

    public statuses: any = {};

    public service_levels: any = {};

    public constructor(
        private router: Router,
        private api3Service: Api3Service,
        private toastService: ToastService,
        private userService: UserService,
        private modalService: ModalService,
        private spinnerService: SpinnerService,
        private serviceLevelService: ServiceLevelService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    private async getOrders(): Promise<any> {
        this.spinnerService.show();
        const {data}: Api.IResponse = await this.api3Service.get(
            `${this.state.section}/shipments/pack-together`
        );

        this.spinnerService.hide();

        if (data) {
            this.shipments = data.shipments;
            this.statuses = data.statuses;
            this.service_levels = data.service_levels;

            this.changeDetectorRef.markForCheck();
        }
    }

    public openOutboundProcedure(wh_order_id: number, order_ref: string, order_id: number): void {
        const path: string[] = [
            "/warehouse",
            this.state.section_slug,
            "procedures-outbound",
            "wizard",
            "order",
            "" + wh_order_id,
            "order_ref",
            order_ref,
            "order_id",
            "" + order_id,
            "back_to",
            btoa(this.router.url)
        ];

        this.router.navigate(path);
    }

    public async exportUniversalPickList(shipment_id: number): Promise<any> {
        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.state.section}/shipments/pack-together/export-pick-list`,
            {
                shipment_id,
                type: "universal"
            }
        );

        this.spinnerService.hide();

        if (code === 200) {
            this.toastService.show(message, "success");
        }
    }

    public ngOnInit(): void {
        this.getOrders();
    }


    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-consolidated",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
